import Text from '@/components/Text';
import { faCheck, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { faTimes, faWallet, faWarning } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface IBadgeVariant {
  className: string;
  icon?: React.ReactNode;
  variant: 'success' | 'info' | 'warning' | 'error' | 'default';
}

const BadgeVariants: Record<'success' | 'info' | 'warning' | 'error' | 'default', IBadgeVariant> = {
  success: {
    className: 'text-success bg-success/10',
    icon: <BadgeIcon icon={faCheck} />,
    variant: 'success',
  },
  info: {
    className: 'text-old-blue-300 bg-old-blue-300/20',
    icon: <BadgeIcon icon={faCheck} />,
    variant: 'success',
  },
  warning: {
    className: 'text-warning bg-warning/10',
    icon: <BadgeIcon icon={faWarning} />,
    variant: 'warning',
  },
  error: {
    className: 'text-u-negative bg-u-negative/10',
    icon: <BadgeIcon icon={faTimes} />,
    variant: 'error',
  },
  default: {
    className: 'bg-darkglass ',
    icon: null,
    variant: 'default',
  },
};

function BadgeIcon({ icon }: { icon: IconDefinition }) {
  return <FontAwesomeIcon icon={icon} className="size-3" />;
}

interface IBadgeProps {
  variant: IBadgeVariant['variant'];
  children?: React.ReactNode | any;
  icon?: React.ReactNode;
  className?: string;
  noIcon?: boolean;
}

const Badge = ({ variant = 'default', noIcon = false, children, icon, className }: IBadgeProps) => {
  const { className: variantClassName, icon: defaultIcon } = BadgeVariants[variant];
  const hasIcon = () => icon || defaultIcon;
  return (
    <span
      className={twMerge(
        'h-8 rounded-full flex gap-2 items-center text-nowrap w-auto px-2',
        icon ? 'pr-3' : '',
        variantClassName,
        className,
      )}
    >
      {!noIcon && hasIcon() && (
        <span className="flex-none size-4 flex items-center justify-center">{icon || defaultIcon}</span>
      )}
      <Text size='sm' className='flex-auto  text-inherit'>{children}</Text>

    </span>
  );
};

export default Badge;
